export default {
    GET_dictJson: '/dqi-hymanage/dict/json/all',//字典
    GET_vehicleBrand: '/dqi-hymanage/dict/vehicleBrand',//获取车辆品牌
    GET_vehicleModel: '/dqi-hymanage/dict/vehicleModel',//根据车辆品牌获取车辆型号
    GET_vehicleStyles: '/dqi-hymanage/dict/vehicleStyles',//根据车辆品牌获取车辆型号
    POST_hyNotice: '/dqi-hymanage/hyNotice/index',//获取公告
    GET_indexCheckStatus: '/dqi-hymanage/statistic/indexCheckStatus',//获取3个统计分析
    // GET_indexCheckStatus: '/dqi-hymanage/statistic/indexCarCheckStatistic',//获取5个统计分析
    GET_wsAddress: '/domeCamera/getWsAddress/',
    GET_charts: '/dqi-hymanage/statistic/indexCarAndPersonFlow',  // 图表数据
    GET_todayFlow: '/dqi-hymanage/statistic/indexTodayFlow',  // 今日流量
    GET_controlRegionEnableList: '/dqi-hymanage/hyControlRegion/enableList',
    POST_deviceControll: '/domeCamera/deviceControll'
}



// WEBPACK FOOTER //
// ./src/http/apiModules/homeAPI.js